import Layout from "global/component/Genericos/Layout/Layout";
import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext } from "react";
import ConsultaIcon from "_+_Portal/assets/images/generico/ConsultaIcon";
import CorazonIcon from "_+_Portal/assets/images/generico/CorazonIcon";
import LaboratorioIcon from "_+_Portal/assets/images/generico/LaboratorioIcon";
import MiInformeIcon from "_+_Portal/assets/images/generico/MiInformeIcon";
import MisLaboratoriosIcon from "_+_Portal/assets/images/generico/MisLaboratoriosIcon";
import TestPcrIcon from "_+_Portal/assets/images/generico/TestPcrIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BtnContainer,
  ContainerNecesitoTurno,
  ContainerOtrosTramites,
  HeaderHomeBar,
  TextNecesitoTurno,
  TextOtrosTramites,
} from "./localStyle";

const OtrosTramites = () => {
  // -------------------------  context ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const { modalDispatch, authState } = useContext(GlobalContext);
  const { selectDropDownState, selectDropDownDispatch } =
    useContext(PortalContext);
  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------
  let config = localStorage.getItem("config");
  // let opcChequeoIntegral = JSON.parse(config).opcChequeoIntegral;

  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState.auth.data.paciente.nombre;
  // -------------------------  constantes ----------------------------


  // -------------------------  funtions ----------------------------
  const handleOnclick = () => {};
  const handleVolver = () => {
    setPaso("Home")(pasoDispatch);
  }
  // -------------------------  funtions ----------------------------


  return (
    <LayoutPasos
      volverTo={handleVolver}
      title={camelize(pacienteNombre)}
      subtitle={"¿En qué podemos ayudarte hoy?"}
    >
      <ContainerOtrosTramites>
        {/* <HeaderHomeBar>
          <span className="title">
            ¡Hola{" "}
            <span className="title-negrita">{camelize(pacienteNombre)}</span>!{" "}
          </span>
          <span className="title-pregunta">
            ¿En que podemos ayudarte <span className="title-negrita">hoy</span>?
          </span>
        </HeaderHomeBar> */}
        <TextOtrosTramites>
          <span className="title-saludo">
            <span className="title-negrita">Seleccioná lo que necesites</span>
          </span>
        </TextOtrosTramites>
        <BtnContainer>
          <BtnLink
            Icon={<MiInformeIcon color={"var(--color-primary)"} />}
            to={"/misinformes"}
            title={"INFORME DE ESTUDIOS MÉDICOS"}
            onclick={handleOnclick}
          />
          <BtnLink
            Icon={<MisLaboratoriosIcon color={"var(--color-primary)"} />}
            to={"/mislaboratorios"}
            title={"RESULTADOS DE LABORATORIO"}
            onclick={handleOnclick}
          />
          {/* {opcChequeoIntegral && (
            <BtnLink
              Icon={<CorazonIcon color={"var(--color-primary)"} />}
              to={"/consultamedica"}
              title={"CHEQUEO INTEGRAL MÉDICO"}
              onclick={handleOnclick}
            />
          )} */}
          <BtnLink
            Icon={<TestPcrIcon color={"var(--color-primary)"} />}
            to={"/proximosturnos"}
            title={"MIS TURNOS"}
            onclick={handleOnclick}
          />
        </BtnContainer>
      </ContainerOtrosTramites>
    </LayoutPasos>
  );
};

export default OtrosTramites;
